import { TaskDependency } from "../../../types/ganttChart";
import { ReactComponent as DependencyIcon } from "../../../assets/icons/dependency.svg";
import chipStyles from "../../../styles/UI/chips.module.css";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setHighlightedTasks } from "../../../store/search";

const DependencyChip = ({
  dependencyArray,
  border,
  size,
  color,
}: {
  dependencyArray?: TaskDependency[];
  border?: boolean;
  size?: number
  color?: string
}) => {
  const dispatch = useAppDispatch();
  const searchHistory = useAppSelector((state) => state.searchSlice.history);
  return (
    <div
      className={`${chipStyles.roundChip} w-`}
      style={{
        backgroundColor: color ?? "var(--col-graph-third-2)",
        border: border ? "1px solid white" : "none",
        height: size,
        width: size
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (dependencyArray && searchHistory.length === 0) {
          dispatch(
            setHighlightedTasks(
              dependencyArray.flatMap((d) => [
                d.idDependentTask,
                d.idPrerequisiteTask,
              ])
            )
          );
        }
      }}
    >
      <DependencyIcon width={size} height={size} />
    </div>
  );
};

export default DependencyChip;
